// ✅ Cleaned & Fixed Version of InsuranceMasterGrid.js
import React, { useState, useEffect } from "react";
import { apiFetch } from "../../api.js";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";

const InsuranceMasterGrid = () => {
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [dropdownValue, setDropdownValue] = useState("NA");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const totalPages = Math.ceil(filteredData.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);

  const handleDropdownChange = (value) => {
    setDropdownValue(value);
    setSearchValue("");
    setFromDate("");
    setToDate("");
  };

  const fetchGridData = async (txt = "") => {
    let what = "inscmpdet";
    const body = {
      prefix: "",
      what: "",
      sp_823: "",
      sp_824: "",
    };
    switch (dropdownValue) {
      case "sp_817":
        what = "inscmpfilterA";
        body.sp_823 = txt;
        break;
      case "sp_818":
        what = "inscmpfilterB";
        body.sp_823 = txt;
        break;
      case "sp_819":
        what = "inscmpfilterC";
        body.sp_823 = txt;
        break;
      case "sp_820":
        what = "inscmpfilterD";
        body.sp_823 = txt;
        break;
      case "sp_821":
        what = "inscmpfilterE";
        body.sp_823 = fromDate;
        body.sp_824 = toDate;
        break;
      case "sp_822":
        what = "inscmpfilterF";
        body.sp_823 = toDate;
        break;
      case "Active":
        what = "inscmpfilterG";
        break;
      case "Inactive":
        what = "inscmpfilterH";
        break;
      default:
        what = "inscmpdet";
    }
    body.what = what;

    try {
      const response = await apiFetch(
        "/api/insmaster/grid",
        { method: "POST", body: JSON.stringify(body) },
      );
      const data = await response.json();
      const formatted = data.map((row) => ({
        sp_812: row.sp_812,
        InsuranceCompany: row.m1_7,
        Fuel: row.sp_823,
        CubicCapacity: row.sp_818,
        RegistrationZone: row.sp_819,
        ModelType: row.sp_820,
        EffectiveFrom: row.sp_821,
        EffectiveTo: row.sp_822,
      }));

      setGridData(formatted);
      setFilteredData(formatted);
      setCurrentPage(1);
    } catch (err) {
      console.log("❌ Grid Load Error", err);
    }
  };

  useEffect(() => {
    fetchGridData();
  }, [dropdownValue]);

  const handleSearch = () => {
    fetchGridData(searchValue);
  };

  const handleEdit = async (row) => {
    try {
      const id = row.sp_812;
      const response = await apiFetch(
        `/api/insurancemaster/edit/${id}`
      );
      if (!response.ok) throw new Error("Failed to fetch");
      const data = await response.json();
      navigate("/InsuranceMaster", {
        state: { editData: data },
      });
    } catch (err) {
      console.error(err);
      alert("Edit fetch error");
    }
  };

  const handleView = async (row) => {
    try {
      const id = row.sp_812;
      const response = await apiFetch(
        `/api/insurancemaster/View/${id}`
      );
      if (!response.ok) throw new Error("Failed to fetch");
      const data = await response.json();
      navigate("/InsuranceMaster", {
        state: { ViewData: data },
      });
    } catch (err) {
      console.error(err);
      alert("View fetch error");
    }
  };

  const handleCopy = async (row) => {
    try {
      const id = row.sp_812;
      const response = await apiFetch(
        `/api/insurancemaster/View/${id}`
      );
      if (!response.ok) throw new Error("Failed to fetch");
      const data = await response.json();
      navigate("/InsuranceMaster", {
        state: { copyData: data },
      });
    } catch (err) {
      console.error(err);
      alert("Copy fetch error");
    }
  };
  /*------------STYLE-------- */
  const styles = {
    pageContainer: {
      width: "100%",
      minHeight: "100vh",
      backgroundColor: "#f4f6f8",
      display: "flex",
      justifyContent: "center",
      padding: "10px",
    },
    container: {
      width: "100%",
      maxWidth: "1300px",
      padding: "20px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    },
    titleRow: {
      textAlign: "center",
      fontSize: "1.6rem",
      fontWeight: "bold",
      marginBottom: "20px",
    },
    filterRow: {
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      justifyContent: "center",
      marginBottom: "20px",
    },
    searchInput: {
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      minWidth: "150px",
      flexGrow: 1,
      maxWidth: "200px",
    },
    select: {
      padding: "8px 10px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      minWidth: "140px",
      flexGrow: 1,
      maxWidth: "200px",
    },
    searchButton: {
      padding: "10px 14px",
      backgroundColor: "#2196F3",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
    addButton: {
      padding: "10px 16px",
      backgroundColor: "#3a28a0ff",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
    tableWrapper: {
      overflowX: "auto",
      width: "100%",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "900px",
    },
    th: {
      padding: "10px",
      backgroundColor: "#8B1E3F",
      color: "#fff",
      border: "1px solid #ddd",
      whiteSpace: "nowrap",
    },
    td: {
      padding: "8px",
      border: "1px solid #ddd",
      fontSize: "0.85rem",
    },
    actionButton: (bg) => ({
      padding: "6px 10px",
      backgroundColor: bg,
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      marginRight: "5px",
    }),
    pagination: {
      marginTop: "15px",
      display: "flex",
      justifyContent: "center",
      gap: "10px",
    },
    pageBtn: {
      padding: "6px 12px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      cursor: "pointer",
    },
  };

  return (
    <Layout>
      <div style={styles.pageContainer}>
        <div style={styles.container}>
          <div style={styles.titleRow}>Insurance Master Grid</div>

          {/* ✅ FILTER BAR */}
          <div style={styles.filterRow}>
            <select
              value={dropdownValue}
              onChange={(e) => handleDropdownChange(e.target.value)}
              style={styles.select}
            >
              <option value="NA">SELECT</option>
              <option value="Active">ACTIVE</option>
              <option value="Inactive">INACTIVE</option>
              <option value="sp_817">INSURANCE COMPANY</option>
              <option value="sp_818">CUBIC CAPACITY</option>
              <option value="sp_819">REGISTRATION ZONE</option>
              <option value="sp_820">MODEL TYPE</option>
              <option value="sp_821">EFFECTIVE DATE</option>
              <option value="sp_822">CLOSE DATE</option>
            </select>

            {/* ✅ Show FROM & TO only when Effective Date OR Close Date is selected */}
            {(dropdownValue === "sp_821" || dropdownValue === "sp_822") && (
              <>
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  style={styles.searchInput}
                />

                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  style={styles.searchInput}
                />
              </>
            )}

            <input
              type="text"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              style={styles.searchInput}
            />

            <button style={styles.searchButton} onClick={handleSearch}>
              Search
            </button>

            <select
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              style={styles.select}
            >
              {[10, 20, 50, 100].map((s) => (
                <option key={s} value={s}>
                  {s} / page
                </option>
              ))}
            </select>

            <button
              style={styles.addButton}
              onClick={() => navigate("/Insurancemaster")}
            >
              Add New
            </button>
          </div>

          {/* ✅ GRID TABLE */}
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>InsuranceCompany</th>
                  <th style={styles.th}>Fuel</th>
                  <th style={styles.th}>CubicCapacity</th>
                  <th style={styles.th}>RegistrationZone</th>
                  <th style={styles.th}>ModelType</th>
                  <th style={styles.th}>EffectiveFrom</th>
                  <th style={styles.th}>EffectiveTo</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((row) => (
                    <tr key={row.sp_812}>
                      <td style={styles.td}>{row.InsuranceCompany}</td>
                      <td style={styles.td}>{row.Fuel}</td>
                      <td style={styles.td}>{row.CubicCapacity}</td>
                      <td style={styles.td}>{row.RegistrationZone}</td>
                      <td style={styles.td}>{row.ModelType}</td>
                      <td style={styles.td}>{row.EffectiveFrom}</td>
                      <td style={styles.td}>{row.EffectiveTo}</td>
                      <td style={styles.td}>
                        <button
                          style={styles.actionButton("#4CAF50")}
                          onClick={() => handleEdit(row)}
                        >
                          Edit
                        </button>
                        <button
                          style={styles.actionButton("#4CAF50")}
                          onClick={() => handleView(row)}
                        >
                          View
                        </button>
                        <button
                          style={styles.actionButton("#673AB7")}
                          onClick={() => handleCopy(row)}
                        >
                          Copy
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} style={styles.td}>
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* ✅ PAGINATION */}
          <div style={styles.pagination}>
            <button
              style={styles.pageBtn}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>

            <span>
              Page {currentPage} of {totalPages || 1}
            </span>

            <button
              style={styles.pageBtn}
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default InsuranceMasterGrid;
